<template>
<div class="home">

   <div v-if="error" class="alert alert-danger">{{ error }}</div>
   <div v-if="wait" class="alert alert-primary">{{ wait }}</div>
   <lc-problem-alert :message="problem"></lc-problem-alert>
   <div v-if="no_blocking_errors">
      <sign-in-form></sign-in-form>
   </div>
   
</div>
</template>

<script>
// @ is an alias to /src
'use strict'
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';
import LcProblemAlert from '@/components/lc-problem-alert';
import SignInForm from '@/components/sign-in-form';


export default {
   name: 'home',

   components: {
      LcProblemAlert,
      SignInForm
   },

   data (){
      return {
         error: null,
         problem: null,
         wait: null,
      };
   },

   computed:{
      
      no_blocking_errors (){
         return !this.problem && !this.wait;
      },

      ...mapGetters([
         'error_message'
      ])
   }, // /computed()

   methods: {
      show_error ( c_message ){
         Object.assign( this, {
            error: c_message,
            problem: null,
            wait: null
         });
      },// /show_error()

      show_problem ( c_message ){
         Object.assign( this, {
            error: null,
            problem: c_message,
            wait: null
         });
      },// /show_problem()

      show_wait ( c_message ){
         Object.assign( this, {
            error: null,
            problem: null,
            wait: c_message
         });
      },// /show_wait()

      clear_show (){
         Object.assign( this, {
            error: null,
            problem: null,
            wait: null
         });
      },// /clear_show()

      ...mapActions([
         'set_page_title'
      ])

   },// methods{}

   mounted (){
      this.set_page_title( '' );

      if( this.error_message ){
         this.show_error( this.error_message );
      }

      // this.show_wait( `Fetching a resource...` );

      // this.fetch_a_resource()
      // .then((o_result]) => {
      //    this.clear_show();
      //    this.results = o_result;
      // })
      // .catch((o_error) => {
      //    this.show_error( o_error.message );
      // });
   },// /mounted()
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.home
{
   max-width: 35em;
   margin: auto;
   background-color: #ffffff;
   padding: 1em;
}
/**
 * Hide the number scroll arrows in number input fields.
 */
/*input[type=number]
{
   -moz-appearance: textfield;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button
{
   -webkit-appearance: none;
   margin: 0;
}*/


/* Small only */
/*@media screen and (min-width: 576px) {}*/

/* Medium and up */
/*@media screen and (min-width: 768px) {}*/

/* Medium only */
/*@media screen and (min-width: 768px) and (max-width: 991px) {}*/

/* Large and up */
/*@media screen and (min-width: 992px) {}*/

/* Large only */
/*@media screen and (min-width: 992px) and (max-width: 1199px) {}*/

/* X-Large and up */
/*@media screen and (min-width: 1200px) {}*/

</style>
